/**
 * FigureAddModal — [이미지 추가]가 여는 **갈래 고르기** 창. 검수 모달과 문제 편집이 같은 창을 쓴다.
 *
 * 왜 한 버튼·한 창인가(오너 지시 2026-09-04 · 2026-09-05 「어떤 경로든 동일 기능·동일 모달」):
 * 머리줄에 버튼이 늘어나면 다른 버튼과 섞여 읽히지 않고, 화면마다 입구가 다르면 같은 일을
 * 다른 자리에서 배워야 한다. 사람이 하려는 일은 「이 자리에 그림을 넣는다」 하나이고,
 * AI 로 짓느냐 파일을 고르느냐 저장된 것을 되살리느냐는 **그다음 선택**이다.
 *
 * 갈래는 대상(target)의 **계약이 허락하는 것만** 낸다 — 눌리면 반드시 실패하는 버튼을 내지 않는다.
 *   · AI 생성            둘 다 (계약 §9-2)
 *   · 이미지 파일 추가    둘 다 — 편집기에 넣고 [저장]이 반영한다(OCR 은 저장이 등록 · 은행은 저장이 곧 목록)
 *   · 저장된 그림에서 고르기  OCR 만 — 서버 목록(payload)과 편집본이 갈리는 화면에서만 뜻이 있다.
 *                            은행은 본문이 곧 목록이라 「서버에는 있는데 본문에 없는 그림」이 없다.
 */
import PropTypes from 'prop-types';
import { ImagePlus, Upload, Images } from 'lucide-react';
import { Modal } from '../common';

export default function FigureAddModal({ isOpen, target, field, onClose, onChoose }) {
  const where = field === 'solution' ? '풀이' : '본문';
  const choose = (kind) => { onClose?.(); onChoose?.(kind); };
  const item = 'flex w-full items-start gap-3 rounded-xl border border-gray-200 bg-white p-3 text-left hover:border-primary';
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`${where}에 이미지 추가`} size="sm" zIndex={9999986}>
      <div className="space-y-2">
        {/* 미저장 편집이 있어도 막지 않는다 — 호스트가 먼저 저장한다(ensureSaved). */}
        <button type="button" className={item} onClick={() => choose('generate')}>
          <ImagePlus className="mt-0.5 size-4 flex-none text-primary" />
          <span>
            <span className="block text-sm font-semibold text-gray-900">AI 생성</span>
            {/* 2026-09-06: 있는 그림의 원본(교재 크롭)으로 그 그림을 다시 그리는 갈래가 생겼다(figureOrigins) — 입구가 그것을 말한다. */}
            <span className="block text-[11px] leading-relaxed text-gray-500">
              {where}의 글을 읽고 그림을 지어 맨 끝에 붙입니다. 이미지를 올리거나, 있는 그림의 원본으로 그 그림을 다시 그릴 수도 있습니다.
            </span>
          </span>
        </button>
        <button type="button" className={item} onClick={() => choose('file')}>
          <Upload className="mt-0.5 size-4 flex-none text-gray-500" />
          <span>
            <span className="block text-sm font-semibold text-gray-900">이미지 파일 추가</span>
            {/* 2026-09-05 부터 은행도 교체(`PATCH {image}`)를 받아(계약 §10-2 G1) 두 화면이 같은 말을 한다. */}
            <span className="block text-[11px] leading-relaxed text-gray-500">
              내 컴퓨터의 이미지를 넣습니다 — 있던 그림을 이 이미지로 바꿀 수도 있습니다.
            </span>
          </span>
        </button>
        {target === 'ocr' && (
          <button type="button" className={item} onClick={() => choose('pick')}>
            <Images className="mt-0.5 size-4 flex-none text-gray-500" />
            <span>
              <span className="block text-sm font-semibold text-gray-900">저장된 그림에서 고르기</span>
              <span className="block text-[11px] leading-relaxed text-gray-500">
                서버가 이 문제에 가진 그림을 다시 넣습니다.
              </span>
            </span>
          </button>
        )}
      </div>
    </Modal>
  );
}

FigureAddModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  target: PropTypes.oneOf(['ocr', 'bank']).isRequired,
  field: PropTypes.oneOf(['body', 'solution']),
  onClose: PropTypes.func.isRequired,
  // 'generate' | 'file' | 'pick'
  onChoose: PropTypes.func.isRequired,
};
